import { render, staticRenderFns } from "./indexDetailsMobile.vue?vue&type=template&id=702aeef8&scoped=true&"
import script from "./indexDetailsMobile.vue?vue&type=script&lang=ts&"
export * from "./indexDetailsMobile.vue?vue&type=script&lang=ts&"
import style0 from "./indexDetailsMobile.vue?vue&type=style&index=0&id=702aeef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702aeef8",
  null
  
)

export default component.exports